<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
      {{ $t("AudioVideoPage.title") }}
    </div>

    <div
      :class="{ 'fanyi-service': true, isActive: active }"
      :style="{ height: height1 }"
    >
      <div class="fanyi-service-left">
        <div class="item1">
          <img class="offline-img" :src="iconShipinImage" alt="" />
          {{ $t("AudioVideoPage.title") }}
        </div>
        <div class="item2">{{ $t("AudioVideoPage.RealTime") }}</div>
      </div>
      <div class="fanyi-service-right">
        <div>
          <img
            class="scan-img"
            :src="scanImage"
            alt=""
            :style="{ marginTop: marginTop }"
          />
        </div>
      </div>
    </div>

    <div class="product-list">
      <div
        :class="{ product: true, isChecked: item.checked }"
        v-for="item in priceList"
        :key="item.id"
        @click="handleCheck(item)"
      >
        <!-- <div class="sale" v-if="item.checked">
          20%{{ $t("AudioVideoPage.sale") }}
        </div> -->
        <div class="checked" v-if="item.checked">
          <img class="checked-img" :src="checkedImg" alt="" />
        </div>
        <div class="product-time">
          {{ item.timeLimit }} {{ getDurationUnitName(item.timeLimitUnit) }}
        </div>
        <div class="product-price">
          {{ $t("AudioVideoPage.RMB") }}{{ item.price }}
        </div>
        <div class="product-del-price">
          {{ $t("AudioVideoPage.RMB") }}{{ item.originalPrice }}
        </div>
      </div>
    </div>

    <div class="describe">
      <div class="subscribe">{{ $t("AudioVideoPage.describe") }}</div>
      <div class="subscribe-content">
        <div>
          {{ $t("AudioVideoPage.describeItem1") }}
        </div>
        <div>{{ $t("AudioVideoPage.describeItem2") }}</div>
        <div>{{ $t("AudioVideoPage.describeItem3") }}</div>
      </div>
    </div>

    <div>
      <el-button class="pay-button" @click="handleConfirm">{{
        $t("OffLinePage.confirm")
      }}</el-button>
    </div>

    <div class="message" v-if="show">
      <div class="tip">{{ message }}</div>
    </div>

    <div class="drawer">
      <el-drawer
        :title="$t('OffLinePage.payType')"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="90%"
        :wrapperClosable="false"
      >
        <div style="padding-bottom: 90px">
          <form id="payment-form" @submit.prevent="handleSubmit">
            <div id="payment-element" />
            <div id="card-errors" class="error" role="alert"></div>
            <button id="submit" class="pay-button" :disabled="isLoading">
              {{ $t("OffLinePage.confirm")
              }}<span v-if="countNumber != 0">¥{{ amount }}</span>
            </button>
          </form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
    
    <script>
import { getOrder, getGoods } from "@/api/login/user";
import { loadStripe } from "@stripe/stripe-js";
const debounce = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  name: "AudioVideoPage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      clientSecret: "",
      productId: "",
      orderNumber: "",
      publishableKey: "",
      isLoading: false,
      marginTop: "20px",
      height1: "88px",
      card: "",
      term: "",
      safetyCode: "",
      name: "",
      drawer: false,
      direction: "btt",
      show: false,
      message: "数量不能为0",
      amount: 0,
      isCard: false,
      isWx: false,
      isGoogle: false,
      countNumber: 1,
      price: 298.88,
      active: false,
      queryParams: "",
      env: process.env.VUE_APP_BASE_API,
      closeImage: require("@/assets/close.png"),
      offlineImage: require("@/assets/offline.png"),
      scanImage: require("@/assets/scan.png"),
      cardImage: require("@/assets/card.png"),
      wxImage: require("@/assets/wx.png"),
      googleImage: require("@/assets/google-pay.png"),
      iconShipinImage: require("@/assets/icon-shipin.png"),
      checkedImg: require("@/assets/gou.png"),
      priceList1: [
        {
          price: "20",
          originalPrice: "20",
          id: 1,
          time: "60分钟",
        },
        {
          price: "35",
          id: 2,
          time: "2小时",
          originalPrice: "88",
        },
        {
          price: "188",
          id: 3,
          time: "24小时",
          originalPrice: "388",
        },
        {
          price: "588",
          id: 4,
          time: "48小时",
          originalPrice: "888",
        },
        {
          price: "10",
          id: 5,
          time: "30分钟",
          originalPrice: "20",
        },
      ],
      priceList: [],
      lang: "cn",
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
      this.getStyle();
    },
  },
  async mounted() {
    this.lang = localStorage.getItem("lang");
    this.getStyle();
    this.getGoodsNet();
  },
  methods: {
    getDurationUnitName(val) {
      console.log("val---", val);
      const list = {
        second: this.$t("AudioVideoPage.time1"),
        minute: this.$t("AudioVideoPage.time2"),
        hour: this.$t("AudioVideoPage.time3"),
        day: this.$t("AudioVideoPage.time4"),
        moon: this.$t("AudioVideoPage.time5"),
        year: this.$t("AudioVideoPage.time6"),
      };
      return list[val];
    },
    getGoodsNet() {
      const params = {
        product_types: "video",
      };
      getGoods(params).then((res) => {
        console.log('getGoods-----res',res);
        if (!res) return;
        if (res?.data?.lists && res?.data?.lists.length != 0) {
          // this.list = res?.data?.lists;
          this.priceList = res?.data?.lists;
          this.priceList.forEach((item) => {
            item.checked = false;
          });
          console.log("this.priceList", this.priceList);
        } else {
          this.show = true;
          this.message = this.$t("basePage.error1");
          setTimeout(() => {
            this.show = false;
          }, 1000);
        }
      });
    },
    async getOrderNet() {
      const data = {
        code: "",
        payType: "stripe",
        productId: this.productId,
        types: "onetime",
        count: this.countNumber,
        orderType:'exchange'
      };
      await getOrder(data).then(async(res) => {
        this.clientSecret = res?.data?.paymentParameters;
        this.orderNumber = res?.data?.orderNumber;
        this.publishableKey = res?.data?.publicSecretKey
        localStorage.setItem("orderNumber", this.orderNumber);
        localStorage.setItem("publishableKey", this.publishableKey);
        this.stripe =  await loadStripe(this.publishableKey, {
          locale: this.$i18n.locale == "cn" ? "zh" : this.$i18n.locale, // 绑定当前语言
        });
        if(this.stripe){
          this.init();
        }
      });
    },
    async init() {
      // const { clientSecret } = await fetch(
      //   "http://127.0.0.1:8080/create-payment-intent",
      //   {
      //     method: "POST",
      //     headers: { "Content-Type": "application/json" },
      //   }
      // ).then((res) => res.json());
      const clientSecret = this.clientSecret;
      const elements = this.stripe.elements({ clientSecret });
      this.elements = elements;
      const options = {
        layout: {
          type: "accordion", // accordion tabs
          defaultCollapsed: true,
          radios: false,
          spacedAccordionItems: true,
        },
      };
      const paymentElement = elements.create("payment", options);
      paymentElement.mount("#payment-element");
      this.isLoading = false;
    },
    async handleSubmit() {
      localStorage.setItem('resultTitle','音/视频通话')
      if (this.isLoading) return;
      this.isLoading = true;
      this.show = true
      this.message = this.$t("OffLineResult.loading")
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/OffLineResult`,
        },
      });
      if (error.type === "card_error" || error.type === "validation_error") {
        this.messages.push(error.message);
        this.$message.error(error.message)
        this.show = false
      } else {
        this.messages.push("An unexpected error occured.");
        this.$message.error("An unexpected error occured.")
        this.show = false
      }
      this.isLoading = false;
    },
    getStyle() {
      if (this.lang == "cn") {
        this.height1 = "88px";
      }
      if (this.lang == "en") {
        this.height1 = "108px";
        this.marginTop = "30px";
      } else {
        this.marginTop = "20px";
      }
      if (this.lang == "ja") {
        this.height1 = "104px";
      }
      if (this.lang == "ru") {
        this.height1 = "124px";
        this.marginTop = "60px";
      } else {
        this.marginTop = "20px";
      }
      if (this.lang == "es") {
        this.height1 = "130px";
        this.marginTop = "60px";
      }
      if (this.lang == "fr" || this.lang == "de") {
        this.height1 = "108px";
        this.marginTop = "30px";
      }
      if (this.lang == "pt" || this.lang == "vi") {
        this.height1 = "124px";
      }
      const list = ["it", "tr", "id", "hi", "ar", "th"];
      if (list.includes(this.lang)) {
        this.height1 = "102px";
      }
    },
    handleConfirm() {
      const result = this.priceList.some((item) => item.checked);
      console.log(result);
      if (!result) {
        this.show = true;
        this.message = this.$t("basePage.message1");
        return;
      } else {
        this.show = false;
      }
      if (!this.productId) {
        this.show = true;
        this.message = this.$t("basePage.error1");
        setTimeout(() => {
          this.show = false;
        }, 1000);
        return;
      }
      this.drawer = true;
      this.getOrderNet();
    },
    handleCheck(val) {
      this.priceList.forEach((item) => {
        if (item.productId === val.productId) {
          item.checked = true;
          this.amount = item.price;
          this.productId = val.productId;
        } else {
          item.checked = false;
        }
      });
      this.$forceUpdate();
    },
    goBack() {
      this.$router.push({
        path: "/RedemptionPage",
      });
    },
    handleAdd() {
      this.countNumber++;
      this.amount = this.countNumber * this.price;
    },
    handleMinus() {
      if (this.countNumber === 0) return;
      this.countNumber--;
      this.amount = this.countNumber * this.price;
    },
    handlePay(val) {
      if (val === "card") {
        this.isCard = !this.isCard;
        this.isWx = false;
        this.isGoogle = false;
        this.drawer = true;
      }
      if (val === "wx") {
        this.isCard = false;
        this.isWx = !this.isWx;
        this.isGoogle = false;
      }
      if (val === "google") {
        this.isCard = false;
        this.isWx = false;
        this.isGoogle = !this.isGoogle;
      }
    },
    toPay() {
      debounce(() => {
        this.$router.push({
          path: "/OffLineResult",
          query: {
            title: "音/视频通话",
            tip: "此码仅用于兑换音/视频通话翻译功能",
          },
        });
      }, 1000);
    },
    handleClose(done) {
      this.show = false;
      done();
    },
  },
};
</script>
    
    <style scoped>
#app {
  height: 100vh;
  text-align: left;
  padding: 0px 16px;
  /* overflow: auto; */
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}

.fanyi-service {
  display: flex;
  width: 100%;
  height: 88px;
  border-radius: 16px;
  margin-top: 16px;
  background: #d0eafc;
}
.fanyi-service1 {
  width: 100%;
  height: 108px;
  border-radius: 16px;
  margin-top: 16px;
  background: #d0eafc;
}
.fanyi-service-left {
  float: left;
}
.item1 {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding: 16px 16px 8px 16px;
  max-width: 240px;
}
.offline-img {
  width: 32px;
  height: 32px;
  padding-right: 8px;
  vertical-align: middle;
}
.item2 {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  padding-left: 16px;
  max-width: 238px;
}
.item3 {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  margin: 16px 0px 0px 16px;

  padding-left: 12px;
  cursor: pointer;

  font-family: Montserrat;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.right-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.fanyi-service-right {
  float: right;
  margin-right: 16px;
}
.icon-right-img {
  width: 16px;
  height: 16px;
}
.right-item1 {
  margin: 22px 0px 32px 32px;
  cursor: pointer;
}
.scan-img {
  width: 50px;
  height: 50px;
  margin-top: 20px;
}
.describe {
  height: 160px;
  border-radius: 16px;
  /* color-white */
  background: #ffffff;
  margin: 16px 0px 100px 0px;
  overflow: auto;
}
.describe-title {
  /* display: flex; */
  height: 52px;
  line-height: 52px;
  padding: 0px 16px;
}
.describe-title-left {
  float: left;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.describe-title-right {
  float: right;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.line {
  width: calc(100% - 32px);
  height: 1px;
  /* 2-底色 */
  border-top: 1px solid #f7f7f7;
  margin: 0px auto 16px;
}
.subscribe {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin-left: 16px;
  padding-top: 16px;
}
.subscribe-content {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  margin: 8px 16px 16px 16px;
  padding-bottom: 16px;
}
.count {
  height: 46px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.count-left {
  float: left;
}
.count-right {
  float: right;
  display: flex;
}
.count-number {
  min-width: 40px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.pay-type-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin: 16px 0px;
}
.line1 {
  width: 100%;
  height: 0px;
  border-top: 1px solid #ebe9e9;
}
.pay-type-content {
  min-width: 120px;
  min-height: 68px;
  border-radius: 8px;
  /* color-white */
  background: #ffffff;
  box-sizing: border-box;
  /* 2-辅色 */
  /* border: 1px solid #201f34; */
  padding: 16px;
  margin-right: 16px;
}
.pay-type-active {
  border: 1px solid #201f34;
}
.pay-type-img {
  width: 20px;
  height: 20px;
}
.pay-type-img1 {
  width: 22px;
  height: 22px;
}
.pay-type-name {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.pay-type {
  display: flex;
  overflow: auto;
  min-height: 70px;
}
.pay {
  margin-top: 16px;
}

.el-button:focus,
.el-button:hover {
  background: #201f34;
  color: #fff;
}

.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  line-height: 60px;
  z-index: 9999;
}
.tip {
  width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 0px 20px;
}
.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
  padding: 0px 16px 90px 16px;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.product {
  position: relative;
  width: 109px;
  height: 112px;
  flex: 0 0 31%;
  /* 自动布局 */
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
  /* margin: 16px 5px 0px 0px; */
  text-align: center;
}
.isChecked {
  border: 2px solid #201f34;
}
.product-time {
  font-family: Source Han Sans;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding: 16px 0px 8px 0px;
}
.product-price {
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding-bottom: 8px;
}
.product-del-price {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  letter-spacing: normal;
  text-decoration: line-through;
  /* 2-辅字 */
  color: #8e8e8e;
}
.product-list {
  display: grid;
  gap: 10px; /* Grid 对 gap 支持更稳定 */
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  margin-top: 16px;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
}
.sale {
  width: 57px;
  position: absolute;
  top: -2px;
  left: -2px;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: normal;
  /* color-white */
  color: #ffffff;
  border-radius: 8px 8px 8px 0px;
  /* 功能色板/Error/colorError */
  background: #ff4d4f;
}
.checked-img {
  width: 31px;
  height: 19px;
  border-radius: 4px 0px 16px 0px;
  /* 2-辅色 */
  background: #201f34;
  position: absolute;
  bottom: -2px;
  right: -2px;
}
.drawer-item {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-bottom: 8px;
}
.drawer-input {
  margin-bottom: 16px;
  border-radius: 8px;
  /* color-white */
  background: #ffffff;
}
.drawer-input >>> .el-input__inner {
  border: none;
}
.pay-button {
  width: calc(100% - 32px);
  position: fixed;
  bottom: 16px;
  min-width: 343px;
  height: 44px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  color: #fff;
  margin: 24px 0px;
}
</style>
    